import React, { useState, useEffect, useRef } from 'react'
import { all_routes } from '../../router/all_routes'
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import "../../../style/css/meetingForm.css";
import * as Yup from "yup";


const MeetingSummery = ({ bd_names, load }) => {


    return (
        <div className="page-wrapper" style={{ backgroundColor: "#faf9f8", minHeight: "100vh" }}>
            <div className="content container-fluid">
                <div style={{ width: '100%', height: '100vh' }}>
                    <iframe
                        src="http://15.207.162.165:8501/"
                        title="Meeting Summary"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                    />

                </div>
            </div>
        </div>
    );
}

export default MeetingSummery

